import ProgressBar from '@luminopia/react-toolbox/lib/progress_bar'
import {Table, TableCell, TableHead, TableRow} from '@luminopia/react-toolbox/lib/table'
import Search from 'core/components/search'
import {pluralize} from 'core/utils/number-helpers'
import {msToMinutes} from 'core/utils/time-helpers'
import * as React from 'react'
import {connect, Dispatch} from 'react-redux'
import Card from 'study_coordinator/components/Card'
import {subjectShowRoute} from 'study_coordinator/routes'
import {getSubjectsRequest, historyPushRequest, IState, selectSubjects} from 'study_coordinator/store'
import * as classNames from './SubjectsListPage.css'
import {IPrescriptionData} from 'core/api/patient'

export interface ISubjectRow {
  subjectIdentifier: string
  accessCode: string
  isTreatmentActive: boolean
  isTreatmentAdherent: boolean
  adherenceDosage: number
  adherenceCompletedDosage: number
  partnerOrderId: string
  prescriptions?: IPrescriptionData[] | null

}
interface IStateProps {
  subjects: ISubjectRow[]
  isFetching: boolean
}

interface IDispatchProps {
  onMount?: () => void
  onClickSubject?: (subjectIdentifier: string) => void
}

interface IOwnProps {}

export interface IProps extends IStateProps, IDispatchProps, IOwnProps {}

interface IComponentState {
  filterValue: string
}

export class SubjectsListPage extends React.Component<IProps, IComponentState> {
  public state = {
    filterValue: '',
  }

  public render() {
    if (this.props.isFetching) {
      return <ProgressBar type='circular' mode='indeterminate' multicolor />
    }

    return (
      <div>
        <Card>
          <Search
            value={this.state.filterValue}
            label='Search by Patient ID or Access Code'
            onChange={this.handleChangeFilterValue}
            onClickClear={() => this.handleChangeFilterValue('')}
          />
          <Table selectable={false}>
            <TableHead>
              <TableCell>Patient ID</TableCell>
              {/* <TableCell>phil patient ID</TableCell> */}
              <TableCell>Access Code</TableCell>
              <TableCell>Recent Usage</TableCell>
              <TableCell>Undergoing Treatment</TableCell>
            </TableHead>
            {this.props.subjects
              .filter((subject) => {
                if (!subject) return false
                const compareValue = this.state.filterValue.toUpperCase()
                return subject.subjectIdentifier.toUpperCase().includes(compareValue) ||
                  subject.accessCode.toUpperCase().includes(compareValue) ||
                  (subject.partnerOrderId && subject.partnerOrderId.toUpperCase().includes(compareValue))
              })
              .map((subject) => ({
                subject,
                hasArchivedPrescription: subject.prescriptions
                  ? subject.prescriptions.some(prescription => prescription.archivedAt !== null)
                  : false
              }))
              .sort((a, b) => {
                if (a.hasArchivedPrescription && !b.hasArchivedPrescription) return 1
                if (!a.hasArchivedPrescription && b.hasArchivedPrescription) return -1
                return 0
              })
              .map(({ subject, hasArchivedPrescription }) => {
                const { onClickSubject } = this.props
                const onClick = () => onClickSubject && onClickSubject(subject.subjectIdentifier)
                const adherenceCompleted = msToMinutes(subject.adherenceCompletedDosage)
                const adherenceDosage = pluralize(msToMinutes(subject.adherenceDosage), 'Minute')
                return (
                  <TableRow
                    key={subject.subjectIdentifier}
                    className={
                      hasArchivedPrescription
                        ? classNames.archived
                        : subject.isTreatmentAdherent
                          ? null
                          : classNames.isNotTreatmentAdherent
                    }
                  >
                    <TableCell className={classNames.cell} onClick={onClick}>{subject.subjectIdentifier}</TableCell>
                    <TableCell className={classNames.cell} onClick={onClick}>{subject.accessCode}</TableCell>
                    <TableCell className={classNames.cell} onClick={onClick}>
                      {`${adherenceCompleted} / ${adherenceDosage}`}
                    </TableCell>
                    <TableCell className={classNames.cell} onClick={onClick}>
                      {subject.isTreatmentActive ? 'Yes' : 'No'}
                    </TableCell>
                  </TableRow>
                )
              })
            }
          </Table>
        </Card>
      </div>
    )
  }

  public componentDidMount() {
    if (this.props.onMount) this.props.onMount()
  }

  private handleChangeFilterValue = (value: string) => {
    this.setState({ filterValue: value })
  }
}

const mapStateToProps = (state: IState, ownProps: IOwnProps): IStateProps => {
  return {
    subjects: selectSubjects(state),
    isFetching: state.subjects.isFetching,
  }
}

const mapDispatchToProps = (dispatch: Dispatch<void>) => ({
  onMount: () => dispatch(getSubjectsRequest()),
  onClickSubject: (subjectIdentifier: string) => dispatch(historyPushRequest(subjectShowRoute(subjectIdentifier))),
})

export default connect<IStateProps, IDispatchProps, IOwnProps, IState>(
  mapStateToProps,
  mapDispatchToProps,
)(SubjectsListPage)



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_coordinator/src/pages/SubjectsListPage.tsx